import React, { Component } from 'react';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5)
}));

class Chips extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div>
                {this.props.filters.length > 0 && (
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'left',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.5,
                            m: 0,
                            boxShadow: 'none',
                            margin: { xs: '2px 0 0 6px', sm: '2px 0 0 6px', md: '16px 0 0px 128px' }
                        }}
                        component="ul"
                    >
                        <Stack direction="row" spacing={1} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' } }}>
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    margin: { xs: '0 12px', sm: '0 12px', md: '0 0 0 0px' }
                                }}
                            >
                                Filters selected:
                            </Typography>
                            {this.props.filters.map((filter, index) => {
                                return (
                                    <ListItem key={`${filter.name}-${index}`}>
                                        <Chip
                                            // icon={<SouthAmericaIcon sx={{ paddingLeft: '6px' }}/>}
                                            label={filter.name}
                                            onDelete={() => {
                                                this.props.handleChipDelete(filter);
                                            }}
                                            sx={{ marginTop: { xs: '12px', sm: '12px', md: '0' } }}
                                        />
                                    </ListItem>
                                );
                            })}
                        </Stack>
                    </Paper>
                )}
            </div>
        );
    }
}

export default Chips;
